import { createGlobalStyle } from 'styled-components';

const GlobalStyles = createGlobalStyle`
  @import url('https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700&display=swap');

  * {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
  }

  body {
    font-family: 'Inter', sans-serif;
    background-color: #0a0a0a;
    color: #ffffff !important;
    --ds-text: #ffffff !important;
    --lns-color-body: #ffffff !important;
    line-height: 1.6;
  }

  h1, h2, h3, h4, h5, h6, p, span, div, a, li {
    color: #ffffff;
  }

  h1, h2, h3, h4, h5, h6 {
    font-weight: 700;
    margin-bottom: 1rem;
  }

  h1 {
    font-size: 3.5rem;
    background: ${props => props.theme.colors.gradient};
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
  }

  h2 {
    font-size: 2.5rem;
    color: ${props => props.theme.colors.secondary};
  }

  p {
    margin-bottom: 1rem;
  }

  button {
    background: ${props => props.theme.colors.gradient};
    color: ${props => props.theme.colors.text};
    border: none;
    padding: 0.75rem 1.5rem;
    border-radius: 5px;
    font-weight: 600;
    cursor: pointer;
    transition: all 0.3s ease;

    &:hover {
      opacity: 0.9;
      transform: translateY(-2px);
    }
  }

  a {
    color: ${props => props.theme.colors.accent};
    text-decoration: none;
  }

  section {
    padding: 5rem 2rem;
  }

  .container {
    max-width: 1200px;
    margin: 0 auto;
  }

  ul {
    list-style: none;
  }
`;

export default GlobalStyles; 